import { SimpleObjectInterface } from '@thewhite/react-global-module/lib/interfaces';
import * as t from 'io-ts';
import BASE_STATUS from '../../Global/enums/baseStatus';

export const SocialStatusType = t.interface({
    id: t.string,
    name: t.union([t.string, t.null, t.undefined]),
    status: t.union([t.string, t.null, t.undefined]),
});

export interface SocialStatusDTO extends t.TypeOf<typeof SocialStatusType> {
}

export class SocialStatus {
    id: string;
    name: string | null;
    status: SimpleObjectInterface | null;

    constructor(params: SocialStatusDTO) {
        this.id = params.id;
        this.name = params.name ?? null;
        this.status = params.status
            ? BASE_STATUS[params.status]
            : null;
    }
}
